import { Tag } from '@cian/components';
import * as React from 'react';

import { IUserIdTag } from '../../../state/tags/definitions/user_id';
import { TagNew } from '../TagNew';
import { tagThemeSmall } from '../tag_theme';

export interface IUserIdTagItemProps {
  tag: IUserIdTag;
  withNewTag?: boolean;
  onDeleteClick(): void;
}

export const UserIdTagItem = ({ onDeleteClick, tag, withNewTag }: IUserIdTagItemProps) => {
  const TagComponent = React.useMemo(() => (withNewTag ? TagNew : Tag), [withNewTag]);

  return (
    <TagComponent onDeleteClick={onDeleteClick} tagStyles={tagThemeSmall}>
      Агент №{tag.value}
    </TagComponent>
  );
};
